// service.js

import google from '../constants/google';

const IMAGE_EXT = google.IMAGE_EXT; // наприклад: ['.jpg','.jpeg','.png']
const VIDEO_EXT = google.VIDEO_EXT; // наприклад: ['.mp4','.mov']

export default function service() {
    const isImageFile = (f) =>
        (f?.type || '').startsWith('image/') ||
        IMAGE_EXT.some(ext => (f?.name || '').toLowerCase().endsWith(ext));

    const isVideoFile = (f) =>
        (f?.type || '').startsWith('video/') ||
        VIDEO_EXT.some(ext => (f?.name || '').toLowerCase().endsWith(ext));

    const isPdf = (f) =>
        (f?.type || '').toLowerCase() === 'application/pdf' ||
        (f?.name || '').toLowerCase().endsWith('.pdf');

    const ts = (f) => {
        const t = Date.parse(f?.mtime || '');
        return Number.isFinite(t) ? t : 0;
    };

    const sortAscByMtime = (arr) => [...(arr || [])].sort((a, b) => ts(a) - ts(b));

    // ✅ Правильний safeJson
    const safeJson = async (res) => {
        if (!res) throw new Error('safeJson: response is undefined/null');

        // деякі бекенди повертають 204 або 205 без тіла
        if (res.status === 204 || res.status === 205) return null;

        const ct = res.headers?.get?.('content-type') || '';
        const text = await res.text(); // читати можна лише один раз
        if (!text) return null;

        // зняти XSSI-префікс якщо є
        const cleaned = text.replace(/^\)\]\}',?\n/, '');

        // необов’язково: попередження, якщо не JSON
        if (!/application\/json/i.test(ct)) {
            console.warn('safeJson: non-JSON content-type:', ct);
        }

        try {
            return JSON.parse(cleaned);
        } catch (e) {
            console.error('safeJson: invalid JSON body:', cleaned);
            // кинемо помилку з коротким описом (щоб не засмічувати UIs довжелезним тілом)
            throw new Error('Invalid JSON: ' + e.message);
        }
    };

    return { isImageFile, isVideoFile, isPdf, sortAscByMtime, safeJson };
}
